module.exports = __webpack_public_path__ + "assets/images/10B.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/10B.png
// module id = 1276
// module chunks = 1